import tw, { styled } from 'twin.macro';

export const StyledSpinner = styled.img`
  ${tw`w-[16px] h-[16px]`}

  @keyframes loading {
    to {
      transform: rotate(1turn);
    }
  }

  animation: loading 0.9s linear infinite;
`;
